'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _ = require('../../');
var _appendLocale = require('../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var HeaderAdditionalLink = function HeaderAdditionalLink(_ref) {var id = _ref.id,link = _ref.link,name = _ref.name,isNew = _ref.isNew,locale = _ref.locale,newPropertyLabel = _ref.newPropertyLabel,onClick = _ref.onClick;return (
    _react2.default.createElement(_reactRouter.Link, _extends({ to: (0, _appendLocale2.default)(locale, link), 'data-link-id': id }, { onClick: onClick }),
      _react2.default.createElement('span', null, name),
      isNew ?

      _react2.default.createElement('span', null, '\xA0\xA0',
        _react2.default.createElement(_.OMLabelNew, {
          label: newPropertyLabel,
          color: '#fd7100' })) :



      null));};




HeaderAdditionalLink.propTypes = {
  id: _propTypes2.default.string,
  link: _propTypes2.default.string,
  name: _propTypes2.default.string,
  isNew: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  newPropertyLabel: _propTypes2.default.string,
  onClick: _propTypes2.default.func };exports.default =


HeaderAdditionalLink;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderDesktop/components/AdditionalLink.js
// module id = 2676
// module chunks = 0